<template>
  <div class="invites-list">
    <v-data-table
      :headers="headers"
      :pagination.sync="pagination"
      :rowsPerPageItems="[rowsPerPage]"
      :items="items"
      hide-actions
      item-key="id"
    >
      <template slot="items" slot-scope="props">
        <tr @click="props.expanded = !props.expanded">
          <!-- <td>
            <v-btn icon >
              <v-icon v-if="!props.expanded">expand_more</v-icon>
              <v-icon v-else>expand_less</v-icon>
            </v-btn>
          </td> -->
          <td>{{ props.item.title }}</td>
          <td>{{ props.item.createdDateFormatted }}</td>

          <td>
            {{ props.item.email && props.item.email.email }}
          </td>

          <td>
            <template v-if="props.item.registeredUser">
              {{ props.item.registeredUser.name }} ({{ props.item.registeredDateFormatted }})
            </template>
          </td>
          <td>
            <v-btn flat icon @click.native.stop="$emit('remove', props.item.id);">
              <v-icon>delete</v-icon>
            </v-btn>
          </td>
        </tr>
      </template>
      <template slot="expand" slot-scope="props">
        <v-card flat>
          <v-card-text>
            <div class="url">
              {{ getUrl(props.item.id) }}
            </div>
            <div v-if="props.item.email && props.item.email.email">
              <p><strong>Тема листа: </strong>{{ props.item.email.subject }}</p>
              <p><div><strong>Текст: </strong></div>{{ props.item.email.text }}</p>
            </div>

            <div v-if="props.item.registeredUser && props.item.registeredUser.uid">
              <div><strong>Зареєстрований користувач</strong></div>
              <p><strong>Ім'я: </strong>{{ props.item.registeredUser.name }}</p>
              <p><strong>Пошта: </strong>{{ props.item.registeredUser.email }}</p>
            </div>
          </v-card-text>
        </v-card>
      </template>
    </v-data-table>
  </div>
</template>

<script>

import moment from 'moment';

const headers = [
  // { text: ' ', width: 1, sortable: false },
  { text: 'Назва', value: 'title' },
  { text: 'Створений', value: 'created' },
  { text: 'Email', value: 'email.email' },
  { text: 'Зареєстрований користувач', value: 'registeredUser' },
  { text: '', width: 1, sortable: false },
];

export default {
  name: 'InvitesList',
  props: {
    invites: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      headers,
      pagination: {
        descending: true,
        sortBy: 'created',
      },
      rowsPerPage: -1,
    };
  },
  computed: {
    items() {
      return this.invites.map(item => ({
        ...item,
        createdDateFormatted: moment(item.created).format('DD.MM.YYYY HH:mm'),
        registeredDateFormatted: item.registeredUser ?
          moment(item.registeredUser.registered).format('DD.MM.YYYY HH:mm') : null,
      }));
    },
    urlPrefix() {
      return `${location.origin}/login/invite/`;
    },
  },
  methods: {
    getUrl(id) {
      return `${this.urlPrefix}${id}`;
    },
  },
};

</script>



// WEBPACK FOOTER //
// src/components/InvitesList.vue